import * as moment from 'moment';
import 'moment-timezone';

// produces nicely formatted date strings. Tries to infer if a date is utc and if it's actually just a date or datetime
class Fmt {

    static dt(strOrNum) {

        let formattedDt = "-";

        if (strOrNum) {

            const dtMoment = moment(strOrNum);
            // this handles string representations of time in 2017-09-13T00:00:00.000Z format
            // or epoch timestamps.
            // this is some questionable logic...
            // 2017-09-13T00:00:00.000Z -> 9/13/2017. To get this, the tz must be UTC. Otherwise, it's the evening of 9/12
            // 2017-09-13T01:23:45.000Z -> 9/12/2017 9:23 PM. To get this, the tz must be America/New_York
            const isStr = typeof strOrNum === "string";
            const dateOnly = isStr && (strOrNum.indexOf("T00:00:00.000") > -1 || strOrNum.indexOf("T") === -1);
            const tz = dateOnly ? "UTC" : "America/New_York";
            const format = dateOnly ? "l" : "l LT";
            formattedDt = dtMoment.tz(tz).format(format);
        }

        return formattedDt;
    }

    static num(n, precision) {
        const p = precision ? precision : 0;

        if (n === Infinity) {
            return "\u221e"
        }

        // http://www.jacklmoore.com/notes/rounding-in-javascript/
        return Number(Math.round(n + 'e' + p) + 'e-' + p).toLocaleString();
    }
}

export default Fmt;


// WEBPACK FOOTER //
// ./src/Fmt.js